import { render, staticRenderFns } from "./Frontali.vue?vue&type=template&id=557546ae&scoped=true"
import script from "./Frontali.vue?vue&type=script&lang=ts"
export * from "./Frontali.vue?vue&type=script&lang=ts"
import style0 from "./Frontali.vue?vue&type=style&index=0&id=557546ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557546ae",
  null
  
)

export default component.exports